/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


if (!customElements.get('eurosec-on-order')) {
  customElements.define('eurosec-on-order', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.form = this.closest('form');
        if (!this.form) return;
        try {
          this.variants = JSON.parse(this.querySelector('[data-on-order-variants]').textContent);
        } catch {
          return;
        }
        this.controller = new AbortController();
        const sync = () => this.sync();
        const options = { capture: true, signal: this.controller.signal };
        ['change', 'input', 'variant:change', 'variant:changed', 'click', 'submit'].forEach(
          type => this.form.addEventListener(type, sync, options)
        );
        this.form.addEventListener('product:rerender', event => {
          const fragment = event.detail?.htmlFragment;
          if (!fragment) return;
          const matchingForm = Array.from(fragment.querySelectorAll('form')).find(
            form => form.getAttribute('id') === this.form.getAttribute('id')
          );
          const data = matchingForm?.querySelector('[data-on-order-variants]');
          if (data) {
            try {
              this.variants = JSON.parse(data.textContent);
            } catch {
              return;
            }
          }
          queueMicrotask(sync);
        }, options);
        this.observer = new MutationObserver(sync);
        this.observer.observe(this.form, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['value']
        });
        this.sync();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }

    sync() {
      const variantControl = Array.from(this.form.elements).find(
        element => element.name === 'id' && !element.disabled &&
          (!['radio', 'checkbox'].includes(element.type) || element.checked)
      );
      const onOrder = this.variants[variantControl?.value]?.on_order === true;
      const inputs = Array.from(this.querySelectorAll('input[data-on-order-injected="true"]'));
      if (!onOrder) {
        inputs.forEach(input => input.remove());
        return;
      }
      const input = inputs.shift() || document.createElement('input');
      inputs.forEach(duplicate => duplicate.remove());
      input.type = 'hidden';
      input.name = 'properties[_on_order]';
      if (input.value !== 'true') input.value = 'true';
      input.dataset.onOrderInjected = 'true';
      if (!input.parentNode) this.append(input);
    }
  });
}
